import { render, staticRenderFns } from "./TurnBlack.vue?vue&type=template&id=a52e36e6&scoped=true&"
import script from "./TurnBlack.vue?vue&type=script&lang=js&"
export * from "./TurnBlack.vue?vue&type=script&lang=js&"
import style0 from "./TurnBlack.vue?vue&type=style&index=0&id=a52e36e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52e36e6",
  null
  
)

export default component.exports